import React from 'react';
import { Box, IconButton, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        py: 2,
        px: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 2,
        backgroundColor: 'rgba(18, 18, 18, 0.75)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        boxShadow: '0 -4px 30px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
      }}
    >
      <Link
        href="https://www.instagram.com/kuarzocontent?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: '#DFDFDF', zIndex: 1300 }}
      >
        <IconButton sx={{ color: '#DFDFDF', zIndex: 1300 }} aria-label="Instagram">
          <InstagramIcon />
        </IconButton>
      </Link>
      <Link
        href="https://www.linkedin.com/company/kuarzocontent/?viewAsMember=true"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: '#DFDFDF' }}
      >
        <IconButton sx={{ color: '#DFDFDF', zIndex: 1300 }} aria-label="LinkedIn">
          <LinkedInIcon />
        </IconButton>
      </Link>
    </Box>
  );
};

export default Footer;
